import { useState } from 'react'
import type { CSSProperties } from 'react'
import type { TimelineSystem } from '@/shared/api'
import { cn } from '@/shared/lib/cn'
import { Icon } from '@/shared/ui'
import { eventToneToken } from '../model/timeline'
import s from './SystemMessage.module.css'

/**
 * Системная запись ленты (`TimelineSystem`) — не от гостя и не от менеджера, а от платформы:
 * сценарий отправил инструкцию, консьерж вмешался. Не пузырь, а сдержанная строка во всю ширину,
 * чтобы не путать с разговором. Если у неё есть `detail` — раскрывается по клику (в макете детали
 * системных записей спрятаны, чтобы не шуметь). Цвет точки — из семантического `tone`, как у
 * событий (`model/timeline`).
 */
export function SystemMessage({ item }: { item: TimelineSystem }) {
  const [open, setOpen] = useState(false)
  const hasDetail = Boolean(item.detail)

  const head = (
    <>
      <span className={s.dot} aria-hidden="true" />
      <span className={s.text}>{item.text}</span>
      <span className={s.time}>{item.timeLabel}</span>
      {hasDetail ? (
        <Icon
          name="chevron-down"
          size={12}
          strokeWidth={2}
          className={cn(s.chevron, open && s.chevronOpen)}
        />
      ) : null}
    </>
  )

  return (
    <div className={s.root} style={{ '--tint': eventToneToken(item.tone) } as CSSProperties}>
      {hasDetail ? (
        <button type="button" className={s.head} onClick={() => setOpen((v) => !v)} aria-expanded={open}>
          {head}
        </button>
      ) : (
        <div className={s.head}>{head}</div>
      )}

      {hasDetail && open ? <p className={s.detail}>{item.detail}</p> : null}
    </div>
  )
}
